import { RichText, Spacer } from '@porsche-code/kado-ui';
import { PInlineNotification } from '@porsche-design-system/components-react';
import { useTranslation } from 'react-i18next';

import { useAnnouncementsQuery } from '@/graphql';
import {
  isAnnouncementCurrentlyActive,
  isUserFeedbackCurrentlyActive,
} from '@/helpers';

import { UserFeedback } from './UserFeedback';

export const Announcement = () => {
  const { t } = useTranslation();

  const { data: announcement } = useAnnouncementsQuery(undefined, {
    select: (data) => data.announcements[0],
  });

  if (!announcement) {
    return null;
  }

  const showAnnouncement = isAnnouncementCurrentlyActive(announcement);
  const showUserFeedback = isUserFeedbackCurrentlyActive(announcement);

  if (!showAnnouncement && !showUserFeedback) {
    return null;
  }

  return (
    <>
      <PInlineNotification
        heading={t('admin.announcement.title')}
        dismissButton={false}
      >
        {showAnnouncement && announcement.message && (
          <RichText value={JSON.parse(announcement.message)} />
        )}
        {showAnnouncement && showUserFeedback && <Spacer mb="md" />}
        {showUserFeedback && announcement.userFeedbackUrl && (
          <UserFeedback url={announcement.userFeedbackUrl} />
        )}
      </PInlineNotification>

      <Spacer mb="lg" />
    </>
  );
};
